import { ListDetailsPage as Page } from './src/page/ListDetailsPage';
import { ListDetailsFiltersProvider } from './src/providers/ListDetailsFiltersProviders';

export const ListDetailsPage = () => (
	<ListDetailsFiltersProvider>
		<Page />
	</ListDetailsFiltersProvider>
);
